// @givmo/app-charity — the director family's addresses in this console (CBG-SEC2 SEC2-WEB).
//
// Board's director pages (my boards, the invitation, the door and every board page) sit at the
// package's own addresses under this console's `/board` mount (`BOARD_DIRECTOR_PAGES`). The three
// email screens are the console's own, in their director arrival (contract §4.3). Spelled once, as
// literals the router can type, and pinned against the package's addresses in
// `director-guard.test.tsx`.

export const DIRECTOR_ROUTES = {
  /** My boards: every board this account has joined. */
  home: '/board/director',
  /** Where every board invitation lands (CBG-FIX14's one link format). */
  invitation: '/board/director/redeem',
  /**
   * CBG-SEC2-L4-MOVE: a director moves their own seat to another Givmo account (D-CBG-23 flow (b)).
   * Like the invitation, it opens signed out: its middle step is the other account's sign-in.
   */
  move: '/board/director/move',
  /** The director door: where the family's guard sends a signed-out visitor. */
  signIn: '/board/director/sign-in',
  /** The console's email sign-in form, in its director arrival. */
  signInEmail: '/board/director/sign-in/email',
  /** The console's create-account form, in its director arrival. */
  signUpEmail: '/board/director/sign-up/email',
  /** The console's email confirmation, in its director arrival. */
  confirmEmail: '/board/director/confirm-email',
  /** The console's organization sign-in step (AS-WEB30), in its director arrival. */
  organizationSso: '/board/director/sso',
  /**
   * The way back in (AS-WEB26) in Board's register (cut 1007e's fold, Board's B-F3): every director
   * side "Lost access to your company sign-in?" opens it, never the console's `/lost-company-access`.
   */
  lostCompanyAccess: '/board/director/lost-company-access',
} as const;
